import { gsap, ScrollTrigger, ScrollToPlugin } from "gsap/all";

export default class ProductFeed {
	constructor() {
		this.getDomElements();

		if (!this.dom.pinnedScroll || !this.dom.cards) return;

		this.cards = [];
		this.navItems = [];
		this.pinnedScrollHeight = 0;
		this.productFeedTimeline = null;

		this.init();
	}

	init() {
		gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
		this.setupCards();
		this.setUpNav();
		this.setPinnedHeight();
		this.handlePinnedScroll();
		this.handleResize();
		this.handleClick();
	}


	setupCards() {
		this.dom.cards.forEach((card, index) => {
			this.cards.push({
				card: card,
				scale: 1,
				image: card.querySelector('.e-media'),
				active: index === 0 ? true : false, // Sets the first to true
			})
		})
	}

	setUpNav() {
		this.dom.navItems.forEach((navItem, index) => {
			this.navItems.push({
				item: navItem,
				active: index === 0 ? true : false, // Sets the first to true
			});
		})
	}

	setPinnedHeight() {
		this.pinnedScrollHeight = window.innerHeight * this.cards.length;
	}

	handlePinnedScroll() {
		let pinnedCards = this.cards;

		this.productFeedTimeline = gsap.timeline({
			ease: "power4.inOut"
		});

		pinnedCards.forEach((cardObject, index) => {
			let cardAnimation;
			if (index === 0)  {
				cardAnimation = gsap.to(cardObject.card, {
					y: 0,
					duration: 0.5,
					onComplete: () => {
						cardObject.active = true;
						this.handleCardState();
						this.handleNavState(index);
					},
					onReverseComplete: () => {
						cardObject.active = false;
						this.handleCardState();
						this.handleNavState(index);
					}
				});
			} else {
				cardAnimation = gsap.fromTo(cardObject.card, {
					y: "100vh",
					autoAlpha: 1
				}, {
					y: 0,
					duration: 0.5,
					onComplete: () => {
						cardObject.active = true;
						this.handleCardState();
						this.handleNavState(index);
					},
					onReverseComplete: () => {
						cardObject.active = false;
						this.handleCardState();
						this.handleNavState(index - 1);
					}
				});
			}

			this.productFeedTimeline.add(cardAnimation).addLabel('anchor-' + index);
		});

		setTimeout(() => {
			ScrollTrigger.create({
				trigger: this.dom.pinnedScroll,
				pin: true,
				scrub: true,
				start: "center center-=80px",
				end: "bottom -100%",
				animation: this.productFeedTimeline,
				invalidateOnRefresh: true,
			});
		}, 750);
	}

	handleCardState(){
		let activeCards = this.cards.filter(card => card.active);
		let activeCardsReverse = Array.from(activeCards).reverse();
		let inActiveCards = this.cards.filter(card => !card.active);

		if (activeCardsReverse.length > 1) {
			activeCardsReverse.forEach((cardObject, index) => {
				if (index != 0) {
					let scale =  1 - (((index) * 2) / 100);
					cardObject.scale = scale;
				} else {
					cardObject.scale = 1;
				}
			});
		} else {
			activeCards.forEach(cardObject => {
				cardObject.scale = 1;
			});
		}

		inActiveCards.forEach(cardObject => {
			cardObject.scale = 1;
		});

		this.animateScales()
	}

	handleClick() {
		this.navItems.forEach((navItem, index) => {
			navItem.item.addEventListener('click', () => {
				let offset = 1;
				gsap.to(window, {
					ease: "power4.inOut",
					duration: 1,
					scrollTo: {
						y: this.productFeedTimeline.scrollTrigger.labelToScroll('anchor-' + index) + offset,
						duration: 5,
					},
					onComplete: () => {
						this.handleNavState(index);
					}
				});
			});
		});
	}

	handleNavState(index) {
		this.navItems.forEach((navItem, navIndex) => {
			if (navIndex === index) {
				navItem.item.classList.add('active');
			} else {
				navItem.item.classList.remove('active');
			}
		});
	}

	handleResize() {
		window.addEventListener('resize', () => {
			// ScrollTrigger.refresh();
			// this.setPinnedHeight();
			location.reload();
		});
	}

	animateScales() {
		this.cards.forEach((cardObject, index) => {
			gsap.to(cardObject.card, {
				scale: cardObject.scale
			})
		});
	}

	getDomElements() {
		this.dom = {
			pinnedScroll: document.querySelector('.js-product-feed'),
			cards: document.querySelectorAll('.js-product-feed-item'),
			navItems: document.querySelectorAll('.js-product-feed-nav-item'),
		}
	}
}
